export const screens = {
	default: '0px',
	xs: '460px',
	sm: '600px',
	md: '900px',
	lg: '1200px',
	xl: '1440px',
	xxl: '1920px',
};

export const container = {
	center: true,
	padding: {
		DEFAULT: '0.5rem',
		xs: '1rem',
		sm: '2rem',
		md: '4rem',
		lg: '5rem',
		xl: '7rem',
		xxl: '8rem',
	},
};

export const defaultColors = {
	colors: {
		neutral: {
			0: '#FFFFFF',
			100: '#F8F8F8',
			300: '#F4F4F4',
			400: '#E8E8E8',
			500: '#DDDDDD',
			600: '#848484',
			700: '#707070',
			800: '#626262',
			900: '#4C4C4C',
			1000: '#2A2A2A',
		},
		orange: {
			100: '#FFF5E9',
			200: '#FFEED8',
			400: '#FDD29B',
			600: '#F2A900',
			700: '#F98E04',
			800: '#EE8805',
			900: '#DC7C01',
			1000: '#EC5E00',
			1050: '#D85300',
			1100: '#D34500',
			1200: '#B93D00',
		},
		green: {
			100: '#D9EFE1',
			150: '#ECF8DB',
			200: '#EDF4C7',
			300: '#C8D400',
			400: '#80CD0D',
			500: '#009639',
			600: '#008030',
			1000: '#005401',
		},
		yellow: {
			100: '#F7FAE7',
			400: '#FFCC00',
			600: '#F2A900',
		},
		blue: {
			500: '#90C9FF',
			1000: '#2D91D2',
		},
		red: {
			100: '#FBE1E1',
			500: '#EB5000',
			800: '#E30613',
			1000: '#CD0037',
		},
		brown: {
			100: '#ECE9E5',
			400: '#CDA788',
			900: '#695033',
		},
	},
};
